export default "__VITE_ASSET__OpaAiv3d__"